import { RunContext } from "components/Run/Context";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import useTypedContext from "hooks/useTypedContext";
import useCanDeleteRunLogs from "shared/Run/access/useCanDeleteRunLogs";
import useRunLogsDeleted from "shared/Run/useRunLogsDeleted";
import { isModuleRunType } from "utils/run";

import { showDeleteRunLogsConfirmation } from ".";
import { getDeleteRunLogsTooltip } from "./helpers";

const DeleteRunLogsMenuItem = () => {
  const { run, stack } = useTypedContext(RunContext);
  const canDeleteRunLogs = useCanDeleteRunLogs();
  const access = canDeleteRunLogs(run);

  const { logsDeleted, logsExpired, loading } = useRunLogsDeleted({ skip: !access.result });

  if (!access.result) {
    return null;
  }

  const tooltip = getDeleteRunLogsTooltip({ logsDeleted, logsExpired });

  return (
    <DropdownMenuItem
      danger
      isDisabled={loading || logsDeleted || logsExpired}
      tooltip={tooltip}
      isTooltipActive={!!tooltip}
      tooltipWidthMode="maxWidthSm"
      tooltipPlacement="left"
      onAction={() =>
        showDeleteRunLogsConfirmation({
          stackId: stack.id,
          runId: run.id,
          isModuleRun: isModuleRunType(run.type),
        })
      }
    >
      Delete run logs
    </DropdownMenuItem>
  );
};

export default DeleteRunLogsMenuItem;
